import { Component, OnInit, HostListener } from '@angular/core';
import { ConnectRestService } from '../services/connect-rest.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AppComponent } from '../app.component';
import { EnglishTranslation, MalayTranslation } from '../app.constants';


declare var $: any;

@Component({
  selector: 'app-confirm-your-company',
  templateUrl: './confirm-your-company.component.html',
  styleUrls: ['./confirm-your-company.component.scss']
})
export class ConfirmYourCompanyComponent implements OnInit {
 
  BusinessName: string;
  BusinessRegNo: string;
  textContent: any;

  constructor(
    private connect: ConnectRestService,
    private formBuilder: FormBuilder,
    public router: Router,
    public appComp: AppComponent) {

  }

  ConfirmCompanyDetails: FormGroup; 

  ngOnInit() {
    var langTranslation = sessionStorage.getItem("language");
    this.textContent = langTranslation == 'en-us' || langTranslation == undefined ? EnglishTranslation.ConfirmYourCompanyScreen : MalayTranslation.ConfirmYourCompanyScreen;

    this.buildForm();
    var resp = JSON.parse(sessionStorage.getItem("ctos-details"));
    // console.log(resp);
    this.BusinessName = resp.CompanyList[0].BusinessName;
    this.BusinessRegNo = resp.CompanyList[0].BusinessRegNo;
    sessionStorage.setItem('CompanyName', resp.CompanyList[0].BusinessName);
  }

  onSubmit() {
  
  }

  buildForm() {
    this.ConfirmCompanyDetails = this.formBuilder.group(
      {
       
      }
    )
  }
}
